<template>
  <div class="com-wrap-DIV">
    <template v-for="(navMenu, navIndex) in navMenus">
      <!-- 最后一级菜单 -->
      <el-menu-item v-if="navMenu && (!navMenu.childs || navMenu.childs.length ==0)"
                    :key="navMenu.id" :index="navMenu.id"
                    :style="{paddingLeft: (navMenu.pId == 0 && !sidebarOpened ? 10 : navMenu.pId == 0 && sidebarOpened ? 20 :45)+'px'}">
        <img v-if="iconShow" v-app-icon="navMenu.icon">
        <a v-if="navMenu.url == ''" href="javascript:;" slot="title"
           @click="routeTo(navMenu,false, navIndex, navMenu.id)" :title="navMenu.name">{{navMenu.name}}</a>
        <a v-else href="javascript:;" slot="title"
           @click="routeTo(navMenu,'true', navIndex, navMenu.id)" :title="navMenu.name">{{navMenu.name}}</a>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu v-if="navMenu.childs && navMenu.childs.length >0" :key="navMenu.id"
                  :index="navMenu.id">
        <template slot="title">
          <img v-if="iconShow" v-app-icon="navMenu.icon">
          <span :title="navMenu.name"> {{navMenu.name}}</span>
        </template>
        <!-- 递归 -->
        <Menu :navMenus="navMenu.childs"></Menu>
      </el-submenu>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Bus from '../eventBus.js'
  // import AdminApi from '../../api/eos/admin'
  import { debounce } from '../../../../utils/DebounceThrottle'
  import DoUrl from '../../../../utils/DoUrl'

  export default {
    name: 'Menu',
    data() {
      return {
        sidebarOpened: false,
        activeIndex: '0'
      }
    },
    props: {
      navMenus: {},
      iconShow: false,
    },
    directives: {
      appIcon: {
        bind: function(el, value) {
          let errorCtrl = false

          const defaultImg = 'http://test.lvya.org/admin/static/icon/menu/app/ico_admin.png'

          if (!value.value) {
            el.src = defaultImg
            return false
          }
          el.src = '/static/icon/menu/TMS/' + value.value + '.png'
          // 在图片加载失败的时候执行onerror方法 给src赋值
          el.onerror = function() {
            if (!errorCtrl) el.src = defaultImg
            errorCtrl = true
          }
        }
      }
    },
    computed: mapState({
      isNavCollapse: state => state.animation.isNavCollapse,
    }),
    mounted() {
    },
    methods: {
      routeTo: debounce(async function(item, path, navIndex, activeIndex) {
        // console.log(item, path, navIndex, activeIndex)
        // 选中路由处理
        if (activeIndex.length >= 0) {
          sessionStorage.activeIndex = activeIndex
        }
        // 刷新页面组件
        if (item.url.indexOf(location.pathname) > -1) {
          let newPath = item.url && item.url.split('#')[1]
          if (newPath == this.$route.path) {
            this.$store.commit('canRenderContent', false)
            setTimeout(() => {
              this.$store.commit('canRenderContent', true)
            }, 150)
          }
        }

        if (!item.url) return
        // 重置iframe url，防止路由重复不重新渲染
        Bus.$emit('iframeShowUrl', '')
        // 微应用渲染方式处理
        if (/\/micro-container/.test(location.href)) {
          console.log('url:', item.url)
          // http链接 直接用iframe渲染
          if (/http/.test(item.url)) {
            Bus.$emit('iframeShowUrl', item.url)
          } else {
            let curUrl = location.href.split('#')[1]
            let url = '/micro-container' + item.url.replace('/index.html', '')
            // 如果重复点击当前页面，刷新一下(加载一个空路由，再重新加载原路由)
            let hashUrl = url.split('#')[1]
            if (curUrl.includes(hashUrl)) {
              let tmpUrl = 'micro-container/#/empty-router'
              window.history.replaceState(null, tmpUrl, tmpUrl)
              window.history.replaceState(null, url, url)
            } else {
              window.history.pushState(null, url, url)
            }
          }
          return false
        }
        // TODO 本地调试素养为admin的应用，需用iframe
        if (location.href.includes('localhost:6060') && item.url.includes('/admin/index.html')) {
          let url = item.url.replace('/admin/index.html', '//localhost:9528')
          setTimeout(() => {
            Bus.$emit('iframeShowUrl', url)
          }, 100)
          return false
        }
        // vue应用，通过router渲染，其他通过iframe渲染
        if (item.url.indexOf(location.pathname) > -1) {
          Bus.$emit('iframeShowUrl', false)
          let path = item.url && item.url.split('#')[1]
          if (path !== this.$route.path) {
            this.$router.push({ path: path })
          }
        } else {
          let resUrl = DoUrl.getTrustCodeUrl(item.url)
          Bus.$emit('iframeShowUrl', resUrl)
        }
      }, 300),
    },
    watch: {
      canRenderContent(val) {
        this.$store.commit('tmsFullDialog', false)
      }
    },
  }
</script>

<style lang="less">
</style>
